<template>
      <div>
           <barra-navegacao :visiblebar="true" :visiblebutton="true"/>
            <b-card
            v-for="(andar,index) in andares" :key="index"
                @click="listarCorredores(andar.idAndar)"               
                class="modern-nav-card">
              <div>
                <strong>{{andar.descricao}}</strong>
              </div>
            </b-card>
      </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },
  data(){
    return{
      blocos: [],
      andares: []
    }
  },

  created(){
    this.listarAndares(this.$route.params.idBloco);
  },

  methods:{
    listarAndares(bloco) {
      this.$http
        .get("/andar/bloco?id_bloco="+bloco)
        .then((res) => {
          this.andares = res.data;
      });
    },
    listarCorredores(idAndar) {
      this.$router.push("/corredor/"+this.$route.params.idBloco+"/"+idAndar)
    },
  }
};
</script>

<style >

</style>